import React from 'react'
import { usePlansContext } from '../../../../hooks/usePlansContext'
import { BodyCell } from '../BodyCell'

export const FamilyPlus = ({
  children,
  spacing,
}: {
  children?: React.ReactNode
  spacing?: number
}) => {
  const { isFamilyPlusSelected } = usePlansContext()

  return (
    <BodyCell isSelected={isFamilyPlusSelected} spacing={spacing}>
      {children}
    </BodyCell>
  )
}
